import React from "react";
import PropTypes from "prop-types";
import { Header, Footer, Sidebar, TopNavBar } from "../common";
import styles from "./MainLayoutStyles.scss";
import { bindActionCreators } from "redux";
import connect from "react-redux/es/connect/connect";
import SideBarMobile from "../common/SideBarMobile/SideBarMobile";
import { IoFastFood } from "react-icons/io5";
import { logout } from "../../store/auth/authActions";
import { FaRegCopyright } from "react-icons/fa6";
import {
  setRowReorderWarningModal,
  resetBannerScreenFilter,
} from "../../store/BannerManagement/BannerManagementActions";
import { persistMenuBar } from "../../store/sidebar/sidebarActions";
import { setNavigatingToOtherPageWarningModal } from "../../store/YouTubeManagement/YouTubeManagementActions";

class MainLayout extends React.Component {
  componentDidMount() {}

  render() {
    const { isOpen, logout, loginUser } = this.props;

    return (
      <div className="page_content_wrapper">
        <Header logout={logout} />
        <Sidebar
          isOpen={isOpen}
          userPermissions={this.props.userPermissions}
          rowReordered={this.props.rowReordered}
          setRowReorderWarningModal={this.props.setRowReorderWarningModal}
          setNavigatingToOtherPageWarningModal={
            this.props.setNavigatingToOtherPageWarningModal
          }
          resetBannerScreenFilter={this.props.resetBannerScreenFilter}
          showSelection={this.props.showSelection}
          //
          persistMenuBar={this.props.persistMenuBar}
        />
        <main className="main">{this.props.children}</main>
        <footer className="footer">
          <span className="me-1">
            <FaRegCopyright />
          </span>
          <span>Copyright 2024. Art of Living. All Rights Reserved.</span>
        </footer>
      </div>
    );
  }
}

MainLayout.propTypes = {
  children: PropTypes.object.isRequired,
  getState: PropTypes.func.isRequired,
  stateLoaded: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout: logout,
      setRowReorderWarningModal: setRowReorderWarningModal,
      setNavigatingToOtherPageWarningModal:
        setNavigatingToOtherPageWarningModal,
      resetBannerScreenFilter: resetBannerScreenFilter,
      persistMenuBar: persistMenuBar,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  isOpen: state.sidebar.isOpen,
  loginUser: state.auth.loginUser,
  userPermissions: state.auth.userPermissions,
  rowReordered: state.bannerManagement.rowReordered,
  showSelection: state.youtubeManagement.showSelection,
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
